import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import Config from '../../../../../Config';
import SwiperCore, {Navigation, Pagination, Autoplay} from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
SwiperCore.use([Pagination, Navigation, Autoplay]);

const ChannelsSwiper = (props) => {
  return (
    <Swiper
      className='swiper-item'
      modules={[Navigation]}
      navigation={props.channels?.length >= 7 ? true : false}
      centerInsufficientSlides={true}
      spaceBetween={14}
      slidesPerView={'auto'}
      scrollbar={{draggable: props.channels?.length >= 7}}
      centeredSlidesBounds={true}
      centeredSlides={true}
      //enabled={props.channels?.length >= 7}
      //autoplay={{ delay: 0, disableOnInteraction: false }}
      pauseOnMouseEnter={true}
      //speed={4000}
      //setWrapperSize={true}
      //loop={props.channels?.length >= 7}
    >
      {props.channels?.map((channel, i) => (
        <SwiperSlide key={i}>
          <div className='chanel-wrapper'>
            <Image src={Config.epiBaseUrl + channel.image} alt='channel picture' />
            <span className='chanel-name' title={channel.channelName}>
              {channel.channelName}
            </span>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
export default ChannelsSwiper;
